<template>
  <section class="interconnect_3">
    <div class="title_box">
      <h2 class="title">互联融合</h2>
    </div>

    <div class="interconnect_list_3">
      <div
        class="item_3 desktop_3 bg_img"
        bg-url="@/plan/assets/image/3/desktop.jpg"
        v-bg
      >
        <h5>无界桌面，万千手机应用轻松上车</h5>
      </div>

      <div class="item_3 sdk_3" bg-url="@/plan/assets/image/3/sdk.png" v-bg>
        <h5 class="sdk_title">妙连 SDK 接入便捷，跨域互通</h5>
      </div>

      <div
        class="item_3 game_3 bg_img"
        bg-url="@/plan/assets/image/3/game.jpg"
        v-bg
      >
        <h5>手机充当虚拟手柄</h5>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Interconnect',
}
</script>

<style lang="less" scoped>
.interconnect_3 {
  height: 1815px;
  background-color: #17181c;
}

.title_box {
  padding: 100px 0 50px 0;
  margin: auto;
  width: 1200px;
}
.title {
  font-weight: 700;
  font-size: 46px;
  line-height: 65px;

  background: linear-gradient(84.93deg, #5881ff -2.12%, #a478ff 97.12%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
}

.interconnect_list_3 {
  width: 1200px;
  height: 100%;
  margin: auto;
}

.item_3 {
  position: relative;
  overflow: hidden;
  background-color: #000;
  display: inline-block;
  height: 720px;

  h5 {
    font-weight: 700;
    font-size: 26px;
    line-height: 37px;
    color: #ffffff;
    padding: 40px 0 0 40px;
  }
}

.desktop_3 {
  width: 1200px;
  border-radius: 30px;
}

.bg_img {
  background-size: 100% 100%;
}

.sdk_3 {
  width: 590px;
  border-radius: 24px;
  overflow: hidden;
  margin-top: 20px;
  background-size: 100%;
}

.game_3 {
  width: 590px;
  height: 720px;
  border-radius: 24px;
  margin: 20px 0 0 20px;
}
</style>
